export enum BreakdownMode {
  DAY_OF_WEEK = 'dayofweek',
  DAY_OF_MONTH = 'dayofmonth',
  MONTH = 'month'
}